// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__100w-rigid-solar-panel_productcontent__bA2kb"};